import React from "react";
import PropTypes from "prop-types";
import { Divider, Grid, Hidden } from "@mui/material";
import { IconButton } from "@totalsoft/rocket-ui";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import RightSidebarContent from "./RightSideBarContent";
import { SidebarDrawer } from "./LayoutStyles";

let showRightSideBarFn;

class RightSidebar extends React.PureComponent {
  showRightSideBar = visible => {
    this.props.showRightSideBar(visible);
  };

  componentDidMount() {
    showRightSideBarFn = this.showRightSideBar;
  }

  render() {
    const { open } = this.props;

    return (
      <div>
        <Hidden mdDown>
          <SidebarDrawer
            variant="persistent"
            anchor="right"
            open={open}
            onClose={this.props.handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true // Better open performance on mobile.
            }}
            //sx={{ displ }}
          >
            <RightSidebarContent />
          </SidebarDrawer>
        </Hidden>

        <Hidden mdUp>
          <SidebarDrawer
            variant="temporary"
            anchor="bottom"
            open={open}
            onClose={this.props.handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true // Better open performance on mobile.
            }}
          >
            <Grid pt="1">
              <IconButton style={{ zIndex: 10001 }} onClick={this.props.handleRightDrawerToggle}>
                <ChevronRightIcon />
              </IconButton>
            </Grid>
            <Divider />
            <RightSidebarContent />
          </SidebarDrawer>
        </Hidden>
      </div>
    );
  }
}

RightSidebar.propTypes = {
  handleRightDrawerToggle: PropTypes.func.isRequired,
  showRightSideBar: PropTypes.func.isRequired,
  i18n: PropTypes.object,
  open: PropTypes.bool
};

export function showRightSideBar(visible) {
  showRightSideBarFn(visible);
}

export default RightSidebar;
